import { Fab, Tooltip } from "@mui/material";
import { Add as AddIcon } from "@mui/icons-material";
import Add from "./Add";
import Edit from "./Edit";
import Permission from "./Permission";
import Remove from "./Remove";

export function ActionsDialogPage({ open, close, instance, reportAction, extraData = {} }) {
  return (<>
    <Add 
      open={open === 1} 
      close={close} 
      reportAction={reportAction} 
      extraData={{ rolesList: extraData.rolesList, branchOfficesList: extraData.branchOfficesList }} />
    <Edit 
      open={open === 2} 
      close={close} 
      instance={instance} 
      reportAction={reportAction} 
      extraData={{ rolesList: extraData.rolesList, branchOfficesList: extraData.branchOfficesList }} />
    <Remove 
      open={open === 3} 
      close={close} 
      instance={instance} 
      reportAction={reportAction} />
    <Permission 
      open={open === 4} 
      close={close} 
      instance={instance} 
      reportAction={reportAction}
      extraData={{ permissionsList: extraData.permissionsList }} />
  </>)
}

export function ActionFabButtonAdd({ t, action }) {
  return (
    <span className="fab_add">
      <Tooltip title={t("qrcode_page_add_button_text")}>
        <Fab color="primary" onClick={action}> <AddIcon /></Fab>
      </Tooltip>
    </span>
  )
}